import { axios } from '@Root/API'

export const get = (qualificationAwardId, qualificationAwardAccreditationId) => {
	return axios.get(`qualification-awarded/${qualificationAwardId}/accreditation/${qualificationAwardAccreditationId}`)
}
